// extracted by mini-css-extract-plugin
export default {"spinner":"Loading_spinner__FIYLT","spin":"Loading_spin__VvKr8"};